import type Highcharts from 'highcharts/highstock';

/**
 * Custom type for the data labels formatter context.
 * This represents the `this` context in a data labels formatter function.
 * In Highcharts 12+, the formatter context is the Point itself.
 */
export interface PointLabelContext {
  /** The current point (for backward compatibility) or undefined if using Point directly */
  point?: Highcharts.Point;
  /** Point index - directly available when `this` is a Point */
  index?: number;
  /** The series containing this point */
  series: Highcharts.Series;
  /** The y value of the point */
  y?: number | null;
}

export const createLastPriceLabel = (dataLabels: PointLabelContext, color: string) => {
  const last = dataLabels.series.points.at(-1)?.index;
  // Support both old style (dataLabels.point.index) and new style (dataLabels.index)
  const pointIndex = dataLabels.point?.index ?? dataLabels.index;
  if (pointIndex === last) {
    const decimalPlaces = dataLabels.series.userOptions.custom?.decimalPlaces;
    const value = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
    }).format(dataLabels.y ?? 0);
    const htmlElementStyle =
      `color: ${color};` +
      ' display: inline-flex; padding: 0 4px 0 4px; justify-content: center;text-align: center;align-items: center;  width:55px;height:15px;font-size: 10px;font-style: normal;font-weight: 400;line-height: normal;' +
      `background-color:${dataLabels.series.color};`;
    return `<div style="${htmlElementStyle}">${value}</div>`;
  }
};
